import React from 'react';
import { useNavigate } from 'react-router-dom';
import LayoutHeader from '../../layout/LayoutHeader';

function AnalyticsHub() {
  const navigate = useNavigate();

  const categories = [
    {
      id: 'tour-manager',
      name: 'Tour Manager',
      description: 'Tour logistics, travel, and crew analytics',
      color: '#FF6B35',
      route: '/analytics/tour-manager'
    },
    {
      id: 'bookings',
      name: 'Bookings',
      description: 'Event performance and ticket sales',
      color: '#FFFF00',
      route: '/analytics/bookings'
    },
    {
      id: 'catalog',
      name: 'Catalog',
      description: 'Music streaming and playlist analytics',
      color: '#17A2B8',
      route: '/analytics/catalog'
    },
    /* Temporarily hidden - not ready for MVP
    {
      id: 'merch',
      name: 'Merch',
      description: 'Product sales and inventory tracking',
      color: '#9932CC',
      badge: 'MR',
      route: '/analytics/merch'
    },
    {
      id: 'charting',
      name: 'Charting',
      description: 'Chart positions and music performance tracking',
      color: '#FF6B35',
      badge: 'CH',
      route: '/analytics/charting'
    },
    {
      id: 'playlisting',
      name: 'Playlisting',
      description: 'Playlist additions and streaming insights',
      color: '#1DB954',
      badge: 'PL',
      route: '/analytics/playlisting'
    },
    {
      id: 'social-listening',
      name: 'Social Listening',
      description: 'Social media mentions and engagement',
      color: '#1DA1F2',
      badge: 'SL',
      route: '/analytics/social-listening'
    },
    */
    // Spotify Revenue analytics temporarily hidden - uses mock data
    // {
    //   id: 'spotify-revenue',
    //   name: 'Spotify Revenue',
    //   description: 'Streaming revenue and payment analytics',
    //   color: '#1DB954',
    //   badge: 'SR',
    //   route: '/analytics/spotify-revenue'
    // }
    // Hiding Pages analytics for now
    // {
    //   id: 'pages',
    //   name: 'Pages',
    //   description: 'Content engagement and page views',
    //   color: '#FF3B30',
    //   badge: 'PG',
    //   route: '/more/analytics'
    // }
  ];

  const handleCategoryClick = (route) => {
    navigate(route);
  };

  return (
    <LayoutHeader>
      <div className="flex justify-center w-full">
        <div className="w-[390px] h-[80vh] flex flex-col items-center relative z-[0]">
          {/* Header */}
          <div className="px-4 mt-[50px] mb-[20px] flex w-full justify-between">
            <span className="text-white text-[14px]" style={{ fontWeight: 300 }}>Analytics Hub</span>
            <div 
              className="text-white cursor-pointer text-[12px] hover:text-gray-400 transition-colors"
              onClick={() => navigate(-1)}
            >
              Back
            </div>
          </div>

          {/* Content - Added pt-12 for proper spacing with overflow */}
          <div className="w-full px-4 flex-1 overflow-y-auto pb-[100px]">
            <div className="grid gap-4 pt-12">
              {categories.map((category) => (
                <div 
                  key={category.id}
                  className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 transition-all cursor-pointer hover:transform hover:scale-[1.02] origin-bottom"
                  style={{
                    '--hover-color': category.color,
                    '--hover-bg': `${category.color}15`
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = category.color;
                    e.currentTarget.style.backgroundColor = `${category.color}15`;
                    e.currentTarget.style.boxShadow = `0 0 20px ${category.color}40`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
                    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.05)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                  onClick={() => handleCategoryClick(category.route)}
                >
                  <div className="flex items-center gap-x-[15px] mb-3">
                    <div 
                      className="w-[32px] h-[32px] rounded-lg"
                      style={{ backgroundColor: category.color }}
                    />
                    <div className="flex items-center gap-x-[10px]">
                      <span className="text-[12px] text-white font-normal">
                        {category.name}
                      </span>
                      <div 
                        className="w-[8px] h-[8px] rounded-full"
                        style={{ backgroundColor: category.color }}
                      />
                    </div>
                    <div className="ml-auto">
                      <svg 
                        className="w-4 h-4 text-white opacity-50"
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  </div>
                  
                  <p className="text-[rgba(255,255,255,0.7)] text-[12px] leading-relaxed">
                    {category.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Help Text with Black Overlay */}
          <div className="w-full absolute bottom-0 left-0">
            <div className="bg-black px-4 pt-8 pb-[27px]">
              <div className="text-[12px] text-[rgba(255,255,255,0.5)] leading-[1.5] max-w-full">
                <p>View comprehensive analytics for each app category.</p>
                <p>Track performance, engagement, and key metrics across your platform.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutHeader>
  );
}

export default AnalyticsHub; 